export default __webpack_public_path__ + "static/media/rudj2.fadcd9e8.jpg";